document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('password-form');
  if (!form) return;
  
  const password = document.getElementById('password');
  const passwordConfirmation = document.getElementById('password_confirmation');
  const currentPassword = document.getElementById('current_password');
  const passwordStrength = document.getElementById('password-strength');
  const passwordError = document.getElementById('password-error');
  const passwordConfirmationError = document.getElementById('password-confirmation-error');
  const currentPasswordError = document.getElementById('current-password-error');
  const formErrors = document.getElementById('form-errors');

  function hasSpecialCharacter(str) {
    const specialChars = '!@#$%^&*()_+-=[]{}|;:,.<>?/~`"\'';
    for (let i = 0; i < str.length; i++) {
      if (specialChars.includes(str[i])) {
        return true;
      }
    }
    return false;
  }

  function validatePassword(password) {
    const minLength = password.length >= 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumbers = /\d/.test(password);
    const hasSpecialChar = hasSpecialCharacter(password);
    return minLength && hasUpperCase && hasLowerCase && hasNumbers && hasSpecialChar;
  }

  function updatePasswordStrength(password) {
    if (!password) {
      passwordStrength.innerHTML = '';
      return;
    }
    const requirements = [
      { met: password.length >= 8, text: 'At least 8 characters' },
      { met: /[A-Z]/.test(password), text: 'Uppercase letter' },
      { met: /[a-z]/.test(password), text: 'Lowercase letter' },
      { met: /\d/.test(password), text: 'Number' },
      { met: hasSpecialCharacter(password), text: 'Special character' }
    ];
    const html = requirements.map(req => 
      `<div class="${req.met ? 'text-success' : 'text-danger'}">
        <i class="fas fa-${req.met ? 'check' : 'times'}-circle"></i> ${req.text}
      </div>`
    ).join('');
    passwordStrength.innerHTML = html;
  }

  function clearErrors() {
    passwordError.textContent = '';
    passwordConfirmationError.textContent = '';
    currentPasswordError.textContent = '';
    formErrors.innerHTML = '';
    password.classList.remove('is-invalid');
    passwordConfirmation.classList.remove('is-invalid');
    currentPassword.classList.remove('is-invalid');
  }

  if (password) {
    password.addEventListener('input', function() {
      updatePasswordStrength(this.value);
      passwordError.textContent = '';
      password.classList.remove('is-invalid');
    });
  }
  
  if (passwordConfirmation) {
    passwordConfirmation.addEventListener('input', function() {
      passwordConfirmationError.textContent = '';
      passwordConfirmation.classList.remove('is-invalid');
    });
  }
  
  if (currentPassword) {
    currentPassword.addEventListener('input', function() {
      currentPasswordError.textContent = '';
      currentPassword.classList.remove('is-invalid');
    });
  }

  if (form) {
    form.addEventListener('submit', function(e) {
      clearErrors();
      let errors = [];
      
      // Password validation
      if (password.value && !validatePassword(password.value)) {
        errors.push('Password must be at least 8 characters long and include uppercase, lowercase, number and special character.');
        passwordError.textContent = 'Password must be at least 8 characters long and include uppercase, lowercase, number and special character.';
        password.classList.add('is-invalid');
      }
      
      // Password confirmation
      if (password.value && password.value !== passwordConfirmation.value) {
        errors.push('Passwords do not match.');
        passwordConfirmationError.textContent = 'Passwords do not match.';
        passwordConfirmation.classList.add('is-invalid');
      }
      
      // Current password required
      if (!currentPassword.value) {
        errors.push('Current password is required.');
        currentPasswordError.textContent = 'Current password is required.';
        currentPassword.classList.add('is-invalid');
      }
      
      if (errors.length > 0) {
        e.preventDefault();
        if (formErrors) {
          formErrors.innerHTML = `<div class='alert alert-danger'><b>Please review the problems below:</b><ul><li>${errors.join('</li><li>')}</li></ul></div>`;
        }
        return false;
      }
    });
  }
}); 